import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import Toggle from 'material-ui/Toggle';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


export default class AnnouncementNotification extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isAnnouncementNotifyEnable:true,
            announcementStartTimeView:"",
            announcementEndTimeView:"",
            errors: {},
            isLoaded: true,
            activeLocation:'',
            timeZone:'',
            message:'',
            announcementMsg:'',
            startDateAnnouncementMsg:this.loadLocationDateTime(),
            endDateAnnouncementMsg:this.loadLocationDateTime(),
            isFocusAnnouncementInput:false,
            isBtnDisabled:true,
            IsOpenAnnouncementStart:true,
            IsOpenAnnouncementEnd:true,
        }

        this._bind(
            'handleChangeToggle',
            'handleMessageChange',
            'handleStartAnnouncementService',
            'handleEndAnnouncementService',
            'handleCancel',
            'loadLocationDateTime'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // this.loadAutoAcceptConfig();
    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        },()=>{
            this.loadAnnouncementNotification();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {

            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.loadAnnouncementNotification();
                });
        }
    }

    loadLocationDateTime(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);

        return moment();
    }

    loadAnnouncementNotification() {

        let activeLocation = this.state.activeLocation;

        let timeZone = Utils.extractTimeZoneFromLocation(activeLocation);
        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        let defaultFromDate = new Date(currentDateTime);

        let self = this;

        if(this.state.isAnnouncementNotifyEnable == false){
            self.setState({
                message:'',
                announcementStartTimeView:"",
                announcementEndTimeView:""
            })
        }

        if(!Utils.isEmptyObj(activeLocation.announcementConfig)){
            //Message Container View
            if(!Utils.isEmpty(activeLocation.announcementConfig.message) && activeLocation.announcementConfig.message != undefined){
                let msg = activeLocation.announcementConfig.message;
                self.setState({
                    message: msg,
                    announcementMsg:msg
                })
            }

            // start time view
            if (!Utils.isEmptyObj(activeLocation.announcementConfig.startTime)) {

                let announcementStartUntil = activeLocation.announcementConfig.startTime.iso;

                // console.log(stopOOUntil);

                let dateFromLT = Utils.formatDateTimeWithTimeZone(new Date(announcementStartUntil),timeZone);
                let dateFromLTObject = new Date(dateFromLT);
                let formattedDateTime = Utils.formatDateTimeWithTimeZone(dateFromLTObject);

                self.setState({
                    timeZone:timeZone,
                    announcementStartTimeView:formattedDateTime,
                    startDateAnnouncementMsg: null,
                    IsOpenAnnouncementStart:true

                });

            }else {
                self.setState({
                    timeZone:timeZone,
                    // announcementStartTimeView:"",
                    IsOpenAnnouncementStart:true

                });
            }

            // end time
            if (!Utils.isEmptyObj(activeLocation.announcementConfig.endTime)) {

                let announcementEndUntil = activeLocation.announcementConfig.endTime.iso;

                let dateFromLT = Utils.formatDateTimeWithTimeZone(new Date(announcementEndUntil),timeZone);
                let dateFromLTObject = new Date(dateFromLT);

                //toggle Notification when Announcement Date ends
                if(defaultFromDate.getTime() > dateFromLTObject.getTime()){

                    this.setState({
                        startDateAnnouncementMsg:null,
                        endDateAnnouncementMsg:null,
                        message:'',
                        announcementStartTimeView:'',
                   })

                    this.setState({
                        isAnnouncementNotifyEnable: false,
                    }, () => {
                        this.setState({
                          announcementEndTimeView:""
                       })
                    })


                }
                else {
                    this.setState({
                        isAnnouncementNotifyEnable: true
                    })
                }

                // var dateObj = new Date(dsDateTime);
                let formattedDateTime = Utils.formatDateTimeWithTimeZone(dateFromLTObject);


                self.setState({
                    timeZone:timeZone,
                    announcementEndTimeView: formattedDateTime,
                    endDateAnnouncementMsg: null,
                    IsOpenAnnouncementEnd:true
                });

            }else {
                self.setState({
                    timeZone:timeZone,
                    // announcementEndTimeView:null,
                    message:"",
                    IsOpenAnnouncementEnd:true
                });
            }
        }else{
            //Disabled state toogle announcement notification
            self.setState({
                isAnnouncementNotifyEnable:false
            })
        }
    }

    handleMessageChange(e){
        this.setState({
            message: e.target.value,
            isBtnDisabled:false
        })
    }


    handleValidation(){

        let isAnnouncementNotifyEnable = this.state.isAnnouncementNotifyEnable;
        // let isAnnouncementEnd = this.state.isAnnouncementEnd;
        let errors = {};
        let formIsValid = true;

        let startDateAnnouncementMsg = this.state.startDateAnnouncementMsg;
        let endDateAnnouncementMsg = this.state.endDateAnnouncementMsg;


        if(this.state.isAnnouncementNotifyEnable == true){

            let self = this;
            let startTimeAnnouncementJSON = self.getUTCDateTimeJSONFromSelectedDateTime(startDateAnnouncementMsg );
            let endingTimeJSON = self.getUTCDateTimeJSONFromSelectedDateTime(endDateAnnouncementMsg);

            let startDate = startTimeAnnouncementJSON.iso;
            let endDate = endingTimeJSON.iso;

            let newStartDateTime = moment(startDate).seconds(0).milliseconds(0).toISOString();
            let newEndDateTime = moment(endDate).seconds(0).milliseconds(0).toISOString();


            if (newStartDateTime >= newEndDateTime){
                formIsValid = false;
                errors["errors"] = "The ending time must occur after the starting time.";
                // alert('The ending time must occur after the starting time.');
            }

            if (Utils.isEmpty(endDateAnnouncementMsg)){
                formIsValid = false;
                errors["errors"] = "End date is required";
            }

            if (Utils.isEmpty(startDateAnnouncementMsg)){
                formIsValid = false;
                errors["errors"] = "Start date is required";
            }

            let message = this.state.message;
            let messageStr = message.replace(/\s{2,}/g,' ').trim();
            if(Utils.isEmpty(messageStr)){
                formIsValid = false;
                errors["errors"] = "Message field cannot be left blank";
            }
        }


        this.setState({errors: errors});
        return formIsValid;
    }

    getUTCDateTimeJSONFromSelectedDateTime(startDateTime){

        var format = 'YYYY/MM/DD HH:mm:ss';
        var dateStringWithTime = moment(startDateTime).format(format);

        var utcDateTime = moment(dateStringWithTime, format).tz("UTC").format();

        return Utils.getDateJson(utcDateTime);

    }

    updateAnnouncementNotificationFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){

            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;

            let self = this;
            self.setState({
                isLoaded : false,
                // isAnnouncementEnd:true,
                errors: {}
            });

            let parameterObject = {};
            let announcementConfig = activeLocation.announcementConfig;

            parameterObject["announcementConfig"] = {};
            let isAnnouncementNotifyEnable = this.state.isAnnouncementNotifyEnable;


            let message = this.state.message;

            //Message field
            if(!Utils.isEmpty(message)){

                let messageStr = message.replace(/\s{2,}/g,' ').trim();
                parameterObject["announcementConfig"]["message"] = messageStr;

            }

           //Start Time Enable/disable
            if(isAnnouncementNotifyEnable == true){

                // Start time
                let startAnnounceDate = this.state.startDateAnnouncementMsg;

                let startingAnnouncementTimeJSON = self.getUTCDateTimeJSONFromSelectedDateTime(startAnnounceDate);

                parameterObject["announcementConfig"]["startTime"] = startingAnnouncementTimeJSON;

                // End Time
                let endAnnounceDate = this.state.endDateAnnouncementMsg;

                let endTimeAnnouncementJSON = self.getUTCDateTimeJSONFromSelectedDateTime(endAnnounceDate);

                parameterObject["announcementConfig"]["endTime"] = endTimeAnnouncementJSON;

            }
            else {
                //Delete object if Announcement Notification is disabled.

                parameterObject["announcementConfig"] = {"__op" : "Delete"};
            }

            // add the location id in objectId key
            parameterObject["objectId"] = locId;


            // console.log(JSON.stringify(parameterObject));

            this.updateAnnouncementConfig(parameterObject);
        }

    }

    updateAnnouncementConfig(paramsObject){

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;
        let self = this;

        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    alert("Announcement Notification are configured successfully");

                    self.setState({
                        isLoaded: true,
                        isBtnDisabled:true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded: true});
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }

    handleResetDate() {

        let AnnouncementMsg = this.state.announcementMsg;

        if(!Utils.isEmptyObj(this.state.announcementStartTimeView) && !Utils.isEmptyObj(this.state.announcementEndTimeView) ){
            this.setState({
                startDateAnnouncementMsg:null,
                endDateAnnouncementMsg:null,
                isBtnDisabled:false,
                IsOpenAnnouncementStart:true,
                IsOpenAnnouncementEnd:true,
                message:AnnouncementMsg,
                errors:""
            });
        }else{
            this.setState({
                startDateAnnouncementMsg:null,
                endDateAnnouncementMsg:null,
                message:"",
                isBtnDisabled:false,
                IsOpenAnnouncementStart:true,
                IsOpenAnnouncementEnd:true,
                errors:""
            })
        }

    }

    handleStartAnnouncementService(date){
        let timeZone = this.state.timeZone;
        this.showStartDateTimeView(moment(date,timeZone));

        let newDate = date.format('MM-DD-YYYY');
        let currentDayDate = moment().format('MM-DD-YYYY');

        if(moment(newDate).isSame(currentDayDate)){
            this.setState({
                IsOpenAnnouncementStart:true,
                isBtnDisabled:false
            })
        }else{
            this.setState({
                IsOpenAnnouncementStart:false,
                isBtnDisabled:false
            })
        }
    }

    showStartDateTimeView(momentDateTime){

        if (this.state.isAnnouncementNotifyEnable == true){

            this.setState({
                startDateAnnouncementMsg : momentDateTime,
            })
        }

    }


    handleEndAnnouncementService(date) {

        let timeZone = this.state.timeZone;
        this.showEndDateTimeView(moment(date,timeZone));

        let newDate = date.format('MM-DD-YYYY');
        let currentDayDate = moment().format('MM-DD-YYYY');

        if(moment(newDate).isSame(currentDayDate)){
            this.setState({
                IsOpenAnnouncementEnd:true,
                isBtnDisabled:false
            })
        }else{
            this.setState({
                IsOpenAnnouncementEnd:false,
                isBtnDisabled:false
            })
        }

    }


    showEndDateTimeView(momentDateTimes){
        if (this.state.isAnnouncementNotifyEnable == true){

            this.setState({
                endDateAnnouncementMsg: momentDateTimes
            })
        }
    }

    handleChangeToggle = (event, eventValue) => {

        this.setState({
            isAnnouncementNotifyEnable: eventValue
        },()=>{
            this.handleResetDate();
        });
    };

    handleCancel(){
        this.props.reloadLocation();
        this.setState({
            errors:"",
            isBtnDisabled:true
        });
    };

    render() {

        return (
            <div className="order-notification">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                <div className="border-class marginTop">
                    <h4 id="translations" className="page-header">Update Announcement Message</h4>
                    <form name="updateLocationForm" className="updateLocationForm"
                          onSubmit={this.updateAnnouncementNotificationFormSubmit.bind(this)}>
                           <div className="row form-group">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <Toggle
                                            id={"isAnnouncementNotifyEnable"}
                                            defaultToggled={this.state.isAnnouncementNotifyEnable}
                                            onToggle={this.handleChangeToggle}
                                            style={{marginTop: 5, width:'100px'}}
                                            thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                            trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                        />

                                        {!Utils.isEmpty(this.state.announcementStartTimeView) && !Utils.isEmpty(this.state.announcementEndTimeView)?
                                            <div>
                                                {this.state.isAnnouncementNotifyEnable == true ?
                                                    (<h5>Announcement Notification Message is <strong>Enabled</strong></h5>)
                                                    : (<h5>Announcement Notification Message is <strong>Disabled</strong></h5>)
                                                }
                                            </div>
                                        :
                                        (   <div>
                                                {this.state.isAnnouncementNotifyEnable == false ?
                                                    (<h5>Announcement Notification Message is <strong>Disabled</strong></h5>)
                                                    : null
                                                }
                                            </div>
                                        )}


                                        {this.state.isAnnouncementNotifyEnable == true ?
                                            <div className="row form-group">
                                                <div className="col-lg-12">
                                                    <div className="form-group msg-contained" style={{marginTop: "25px"}}>
                                                        <label htmlFor="labelName">Please Enter Your Message</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            id="message" ref="message"
                                                            aria-describedby="message"
                                                            placeholder="Enter Your Message"
                                                            onChange={this.handleMessageChange}
                                                            value={this.state.message}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }

                                    </div>
                                </div>
                            </div>

                            <div className="row form-group">
                                <div className="col-lg-6">
                                    {this.state.announcementStartTimeView && this.state.isAnnouncementNotifyEnable == true?
                                        <div className="row col-lg-12">
                                            <h5>Please Enter Your Start Date</h5>
                                                <h5>
                                                    <b>Starting from {this.state.announcementStartTimeView}</b>
                                                </h5>
                                        </div>
                                        : null
                                    }

                                    {
                                        this.state.isAnnouncementNotifyEnable == true  ? (
                                            <div className="row">
                                                <div className="col-lg-12">

                                                    <div className="">
                                                        <i className="fa fa-announcement fa-calendar"></i>
                                                        <DatePicker
                                                            // utcOffset={-6}
                                                            selected={this.state.startDateAnnouncementMsg}
                                                            onChange={this.handleStartAnnouncementService}
                                                            popperClassName='deliveryInput'
                                                            minDate={moment()}
                                                            minTime={this.state.IsOpenAnnouncementStart ? moment() : moment().set({
                                                                h: 0,
                                                                m: 0
                                                            })}
                                                            maxTime={moment().set({h: 23, m: 45})}
                                                            showTimeSelect
                                                            dateFormat="LLL"
                                                            title="Choose the date time"
                                                            placeholderText={"Choose the Date Time"}
                                                            timeIntervals={30}
                                                            onChangeRaw={(e) => e.preventDefault()}
                                                            onFocus={(e) => e.target.readOnly = true}
                                                            shouldCloseOnSelect={false}

                                                        >
                                                            <div
                                                                className="title-container-new align-items-center justify-content-center">

                                                                {this.state.announcementStartTimeView ? (
                                                                    <div>
                                                                        <span
                                                                            className="online-ordering-until"> Announcement message starts from <br/></span>
                                                                        <span
                                                                            className="Online-dateTime-view">{this.state.announcementStartTimeView}</span>
                                                                    </div>

                                                                    ) : <div className="container-datetime">
                                                                            <span> Choose the Date & Time </span>
                                                                        </div>
                                                                    }

                                                            </div>
                                                        </DatePicker>
                                                    </div>

                                                </div>
                                            </div>
                                        ) : null
                                    }
                                </div>
                                <div className="col-lg-6">
                                    {this.state.announcementEndTimeView && this.state.isAnnouncementNotifyEnable == true  ?
                                        (<div className="row col-lg-12">
                                            <h5>Please Enter Your End Date</h5>
                                                <h5>
                                                    <b>Until {this.state.announcementEndTimeView}</b>
                                                </h5>
                                        </div> )
                                        : null
                                    }
                                    {
                                        this.state.isAnnouncementNotifyEnable == true  ? (
                                            <div className="row">
                                                <div className="col-lg-12">

                                                        <i className="fa fa-announcement fa-calendar"></i>
                                                        <DatePicker
                                                            // utcOffset={-6}
                                                            selected={this.state.endDateAnnouncementMsg}
                                                            onChange={this.handleEndAnnouncementService}
                                                            minDate={moment()}
                                                            minTime={this.state.IsOpenAnnouncementEnd ? moment() : moment().set({
                                                                h: 0,
                                                                m: 0
                                                            })}
                                                            maxTime={moment().set({h: 23, m: 45})}
                                                            showTimeSelect
                                                            dateFormat="LLL"
                                                            placeholderText={"Choose the Date Time"}
                                                            timeIntervals={30}
                                                            onChangeRaw={(e) => e.preventDefault()}
                                                            onFocus={(e) => e.target.readOnly = true}
                                                            shouldCloseOnSelect={false}
                                                        >
                                                            <div
                                                                className="title-container-new align-items-center justify-content-center">

                                                                {this.state.announcementEndTimeView ? (
                                                                    <div>
                                                                        <span
                                                                            className="online-ordering-until">Announcement message ends from <br/></span>
                                                                        <span
                                                                            className="Online-dateTime-view">{this.state.announcementEndTimeView}</span>
                                                                    </div>

                                                                ) : <div
                                                                    className="container-datetime">
                                                                        <span> Choose the Date & Time </span>
                                                                    </div>
                                                                }

                                                            </div>

                                                        </DatePicker>
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                            <hr></hr>

                            <div className="form-group">
                                <button type="submit" className={this.state.isBtnDisabled ? "btn-save btn btn-export" : "btn btn-export"}>Save</button>
                                <button type="button" className="btn btn-default back-button"
                                        onClick={this.handleCancel}>Cancel
                                </button>

                            </div>
                            <hr></hr>

                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/announcement-notification.js